import type { IconDefinition } from '../index.tsx';

export const iconSquarePollVertical: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconSquarePollVertical',
  icon: [
    16,
    16,
    [],
    '',
    'M13.7143 0C14.975 0 16 1.02321 16 2.28571V13.7143C16 14.975 14.975 16 13.7143 16H2.28571C1.02321 16 0 14.975 0 13.7143V2.28571C0 1.02321 1.02321 0 2.28571 0H13.7143ZM4.57143 6.85714C3.93929 6.85714 3.42857 7.36786 3.42857 8V11.4286C3.42857 12.0607 3.93929 12.5714 4.57143 12.5714C5.20357 12.5714 5.71429 12.0607 5.71429 11.4286V8C5.71429 7.36786 5.20357 6.85714 4.57143 6.85714ZM6.85714 11.4286C6.85714 12.0607 7.36786 12.5714 8 12.5714C8.63214 12.5714 9.14286 12.0607 9.14286 11.4286V4.57143C9.14286 3.93929 8.63214 3.42857 8 3.42857C7.36786 3.42857 6.85714 3.93929 6.85714 4.57143V11.4286ZM11.4286 9.14286C10.7964 9.14286 10.2857 9.65357 10.2857 10.2857V11.4286C10.2857 12.0607 10.7964 12.5714 11.4286 12.5714C12.0607 12.5714 12.5714 12.0607 12.5714 11.4286V10.2857C12.5714 9.65357 12.0607 9.14286 11.4286 9.14286Z',
  ],
};
